<template>
  <ul class="share">
    <li v-for="socialMediaItem in socialMediaLink">
      <!--      <button type="button" @click="copyLinkFunction()" v-if="socialMediaItem.hasCopyLink">
        <i :class="socialMediaItem.icon"></i>
        <span class="d-none">{{ socialMediaItem.name }}</span>
      </button>-->

      <a :href="getShareLink(socialMediaItem.src)" target="_blank">
        <i :class="socialMediaItem.icon"></i>
        <span class="d-none">{{ socialMediaItem.name }}</span>
      </a>
    </li>
    <!--    <li class="copyLink">
      <small class="copyLink&#45;&#45;alert rounded-pill bg-hazelgreen text-white p-1 px-2" v-show="showCopyAlert">{{$t('Link wurde in die Zwischenablage kopiert')}}</small>
      <button class="copy" @click="copyLink">
        <i class="icon-link"></i>
      </button>
      <input
        @focus="$event.target.select()"
        ref="copyinput"
        readonly
        class="copyLink&#45;&#45;copyinput"
        :value="getCurrentLink()"/>
    </li>-->
    <!--    <li>
      <button class="close" @click="toggleClass">
        <i class="icon-x"></i>
      </button>
    </li>-->
  </ul>
</template>

<script>
export default {
  name: 'Share',

  data() {
    return {
      isActive: false,
      showCopyAlert: false,

      hasCopyLink: {
        type: Boolean,
        default: false,
      },

      socialMediaLink: [
        {
          src: 'https://twitter.com/intent/tweet?text=&url=',
          name: 'Twitter',
          icon: 'icon-twitter',
        },
        {
          src: 'https://www.facebook.com/sharer/sharer.php?u=',
          name: 'Facebook',
          icon: 'icon-facebook',
        },
        {
          src: 'https://www.linkedin.com/sharing/share-offsite/?url=',
          name: 'Linked In',
          icon: 'icon-linkedin',
        },
        /* {
          src: 'mailto:?body=',
          name: 'Als Mail weiterleiten',
          icon: 'icon-mail'
        }*/
      ],
    };
  },
  watch: {
    showCopyAlert() {
      setTimeout(() => {
        this.setCopyAlert(false);
      }, 2000);
    },
  },

  methods: {
    getCurrentLink() {
      if (process.client) {
        return window.location.origin + this.$router.currentRoute.path;
      } else {
        return this.$i18n['__baseUrl'] + this.$router.currentRoute.path;
      }
    },

    getShareLink(linkBase) {
      return linkBase + this.getCurrentLink();
    },
    copyLink() {
      this.setCopyAlert(true);
      this.$refs.copyinput.focus();
      document.execCommand('copy');
    },
    setCopyAlert(val) {
      this.showCopyAlert = val;
    },
  },
};
</script>

<style scoped lang="scss">
.share {
  margin: 0 -5px;
  padding: 0;
  list-style: none;
  display: flex;

  li {
    margin: 0 5px 5px;

    a {
      width: 50px;
      height: 50px;
      border: 1px solid $border-color;
      color: $grey-900;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: $transition-base;
      text-decoration: none;

      &::before {
        font-size: 20px;
      }

      &:hover {
        text-decoration: none;
        background: $grey-900;
        border-color: $grey-900;
        color: $white;
      }
    }
  }
}
</style>
